import { serverurl } from '../../../environments/environment';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Easy2Service } from '../../service/easy2.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-intern-landing-page',
    standalone: false,
    templateUrl: './intern-landing-page.component.html',
    styleUrl: './intern-landing-page.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class InternLandingPageComponent implements OnInit {
    easy2Service = inject(Easy2Service);
    readonly dialogRef = inject(MatDialogRef<InternLandingPageComponent>);
    readonly data = inject<any>(MAT_DIALOG_DATA);
    readonly route = inject(ActivatedRoute);
    readonly serverurl = serverurl;

    showDialogHeader: boolean = true;
    pId: any;
    jd: any;

    async ngOnInit(): Promise<void> {

        this.pId = this.data.projectId;
        if (!this.pId) {
            this.pId = await this.route.snapshot.queryParams["pid"];
            this.showDialogHeader = false;
        }

        if (!this.pId) {
            alert("View not possible URL not correct!")
            return;
        }


        let result: any = await this.easy2Service.getInternLandingPageJSON(this.pId);
        this.jd = result.data;
        console.log("JD", this.jd);




    }

    close() {
        this.dialogRef.close();
    }
}


